(function() {
  'use strict';

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.wim-bought-together').forEach(container => {
      if (container._wimBTInit && container.querySelector('.wim-bought-together__comp')) return;
      container._wimBTInit = true;
      new WimBoughtTogether(container);
    });
  }

  // Expose globally for manual calls
  window.wimInitBoughtTogether = init;

  class WimBoughtTogether {
    constructor(el) {
      this.el = el;
      this.el._wimBTInstance = this;
      this.slot = el.querySelector('.wim-bought-together__slot');
      this.url = el.dataset.recommendationsUrl;
      this.baseUrl = el.dataset.baseRecommendationsUrl;
      this.jsonUrl = el.dataset.jsonUrl;
      this.baseJsonUrl = el.dataset.baseJsonUrl;
      this.productId = el.dataset.productId;
      const rawFallbacks = el.dataset.fallbackIds;
      this.fallbackIds = rawFallbacks ? rawFallbacks.split(',').filter(Boolean) : [];
      this.productAvailable = el.dataset.productAvailable !== 'false';
      this.variantAvailable = el.dataset.variantAvailable !== 'false';
      this.behavior = el.dataset.addBehavior || 'juntos';

      // Si el producto principal no tiene stock en modo juntos, ocultar inmediatamente
      if (!this.productAvailable && this.behavior === 'juntos') {
        el.style.display = 'none';
        return;
      }

      this.updateMainForm();

      // Close button logic
      const closeBtn = el.querySelector('.wim-bought-together__close');
      if (closeBtn && !closeBtn._wimBTBound) {
        closeBtn._wimBTBound = true;
        closeBtn.addEventListener('click', () => {
          el.style.display = 'none';
        });
      }

      // Check if slot already has pre-rendered items from Liquid
      const preRendered = this.slot ? this.slot.querySelectorAll('.wim-bought-together__comp') : [];
      if (preRendered.length > 0) {
        this.bindItems(Array.from(preRendered));
        this.el.style.display = '';
        return;
      }

      // Fetch complementary products
      if (this.url || this.jsonUrl) {
        this.fetchProducts();
      }
    }

    updateMainForm() {
      // Find the main product form on the PDP to attach our checkboxes
      const configuredFormId = this.el.dataset.mainFormId;
      if (configuredFormId && document.getElementById(configuredFormId)) {
        this.mainFormId = configuredFormId;
      } else {
        const mainForm = document.querySelector('form[action*="/cart/add"]');
        this.mainFormId = mainForm ? mainForm.getAttribute('id') : '';
      }

      // If checkboxes are already rendered, update their form attribute
      if (this.slot && this.mainFormId) {
        this.slot.querySelectorAll('input[type="checkbox"]').forEach(cb => {
          cb.setAttribute('form', this.mainFormId);
        });
      }
    }

    formatPrice(cents) {
      if (window.theme?.Currency?.formatMoney) {
        return window.theme.Currency.formatMoney(cents, window.theme?.settings?.moneyFormat);
      }
      return `${(cents / 100).toFixed(2).replace('.', ',')} €`;
    }

    createCompElement(product) {
      if (!product || product.available === false) return null;
      const variant = product.variants && product.variants.find(v => v.available);
      if (!variant) return null;

      const item = document.createElement('div');
      item.className = 'wim-bought-together__comp flex items-center';
      item.dataset.variantId = variant.id;
      item.style.cssText = 'background: #ffffff; border-radius: 8px; padding: 12px; gap: 16px; cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.04);';

      const imgSrc = product.featured_image ? (product.featured_image.startsWith('//') ? 'https:' + product.featured_image : product.featured_image) : '';

      item.innerHTML = `
        <div style="width: 56px; height: 56px; flex-shrink: 0; background: #f5f5f5; border-radius: 6px; overflow: hidden;">
          ${imgSrc ? `<img src="${imgSrc}" alt="${product.title || ''}" class="w-full h-full object-contain" loading="lazy" width="112" height="112">` : ''}
        </div>
        <div class="flex flex-col grow" style="gap: 4px;">
          <span class="font-medium leading-tight" style="font-size: var(--text-base); color: rgb(var(--color-foreground));">${product.title}</span>
          <span class="font-medium" style="font-size: var(--text-sm);">
            ${this.formatPrice(variant.price)}
          </span>
        </div>
        <input type="checkbox" autocomplete="off" style="width: 20px; height: 20px; border-radius: 4px; accent-color: rgb(var(--color-foreground)); flex-shrink: 0; cursor: pointer; border: 1.5px solid rgb(var(--color-foreground) / 0.2); box-shadow: 0 0 0 1px rgb(var(--color-foreground) / 0.05);">
      `;
      return item;
    }

    bindItems(items) {
      items.forEach(item => {
        if (item._wimBound) return;
        item._wimBound = true;
        const cb = item.querySelector('input[type="checkbox"]');
        
        if (this.behavior === 'juntos') {
          if (cb) {
            cb.checked = false;
            cb.setAttribute('autocomplete', 'off');
            if (this.mainFormId) {
              cb.name = 'bundles';
              cb.setAttribute('form', this.mainFormId);
              cb.value = item.dataset.variantId;
            }
          }

          // Make entire row clickable
          item.addEventListener('click', (e) => {
            if (e.target.tagName === 'INPUT') return;
            if (cb) cb.checked = !cb.checked;
          });
        } else if (this.behavior === 'inmediato') {
          // Immediate add to cart behavior
          if (cb) cb.checked = false;
          
          item.addEventListener('click', async (e) => {
            if (e.target.tagName === 'INPUT' && !cb.checked) return;
            if (item.classList.contains('is-adding')) return;
            
            if (cb) cb.checked = true;
            item.classList.add('is-adding');
            item.style.opacity = '0.5';

            try {
              const rootUrl = window.Shopify?.routes?.root || '/';
              const addRes = await fetch(rootUrl + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(item.dataset.variantId, 10), quantity: 1 }] })
              });
              await addRes.json();

              if (window.theme?.pubsub) {
                const cart = await fetch(rootUrl + 'cart.js').then(r => r.json());
                window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-bundle', cart
                });
              }
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
              setTimeout(() => { if (cb) cb.checked = false; }, 500);

            } catch(err) {
              console.error('[WIM BT] Add to cart error:', err);
              if (cb) cb.checked = false;
            } finally {
              item.classList.remove('is-adding');
              item.style.opacity = '1';
            }
          });
        }
      });

      if (!items || items.length === 0 || (!this.productAvailable && this.behavior === 'juntos')) {
        this.el.style.display = 'none';
      } else {
        this.el.style.display = '';
      }
    }

    renderItems(items) {
      this.slot.innerHTML = '';
      items.forEach(item => this.slot.appendChild(item));
      this.bindItems(items);
    }

    async tryJsonFetch(jsonUrl) {
      if (!jsonUrl) return false;
      try {
        const res = await fetch(jsonUrl);
        if (!res.ok) return false;
        const data = await res.json();
        if (data && data.products && data.products.length > 0) {
          const elements = [];
          for (const prod of data.products) {
            const el = this.createCompElement(prod);
            if (el) elements.push(el);
          }
          if (elements.length > 0) {
            this.renderItems(elements);
            return true;
          }
        }
      } catch (e) {
        console.warn('[WIM BT] JSON fetch error:', e);
      }
      return false;
    }

    async fetchProducts(targetUrl) {
      const urlToFetch = targetUrl || this.url;
      try {
        if (urlToFetch) {
          const res = await fetch(urlToFetch);
          if (res.ok) {
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const items = Array.from(doc.querySelectorAll('.wim-bought-together__comp'));

            if (items.length > 0) {
              this.renderItems(items);
              return;
            }
          }
        }
      } catch (err) {
        console.warn('[WIM BT] HTML fetch error, trying JSON fallback:', err);
      }

      // Fallback 1: Direct JSON API for current product
      if (this.jsonUrl) {
        const jsonSuccess = await this.tryJsonFetch(this.jsonUrl);
        if (jsonSuccess) return;
      }

      // Fallback 2: Check fallback sibling IDs (both JSON and HTML)
      while (this.fallbackIds && this.fallbackIds.length > 0) {
        const nextId = this.fallbackIds.shift();
        if (this.baseJsonUrl) {
          const ok = await this.tryJsonFetch(`${this.baseJsonUrl}&product_id=${nextId}`);
          if (ok) return;
        }
        if (this.baseUrl) {
          try {
            const fbRes = await fetch(`${this.baseUrl}&product_id=${nextId}`);
            if (fbRes.ok) {
              const fbHtml = await fbRes.text();
              const fbDoc = new DOMParser().parseFromString(fbHtml, 'text/html');
              const fbItems = Array.from(fbDoc.querySelectorAll('.wim-bought-together__comp'));
              if (fbItems.length > 0) {
                this.renderItems(fbItems);
                return;
              }
            }
          } catch (e) {}
        }
      }

      // No recommendations found anywhere - keep hidden
      this.el.style.display = 'none';
    }
  }

  // MutationObserver to detect dynamically inserted or replaced .wim-bought-together elements
  let debounceTimer = null;
  function debouncedInit() {
    if (debounceTimer) cancelAnimationFrame(debounceTimer);
    debounceTimer = requestAnimationFrame(() => init());
  }

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      let needsInit = false;
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) { // ELEMENT_NODE
              if (node.classList && node.classList.contains('wim-bought-together')) {
                needsInit = true;
                break;
              }
              if (node.querySelector && node.querySelector('.wim-bought-together')) {
                needsInit = true;
                break;
              }
            }
          }
        }
        if (needsInit) break;
      }
      if (needsInit) {
        debouncedInit();
      }
    });

    const startObserving = () => {
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserving);
    } else {
      startObserving();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => init());
  document.addEventListener('wim:section:updated', (e) => {
    init(e.detail && e.detail.container ? e.detail.container : document);
  });

  // Listen to variant changes to update form connections and stock availability
  const onVariantUpdate = (event) => {
    const variant = event?.detail?.variant || event?.data?.variant;
    document.querySelectorAll('.wim-bought-together').forEach(container => {
      if (container._wimBTInstance) {
        const inst = container._wimBTInstance;
        inst.updateMainForm();
        if (variant && inst.behavior === 'juntos') {
          const hasItems = container.querySelectorAll('.wim-bought-together__comp').length > 0;
          if (!variant.available || !hasItems) {
            container.style.display = 'none';
          } else {
            container.style.display = '';
          }
        }
      }
    });
  };
  const resetCheckboxes = () => {
    document.querySelectorAll('.wim-bought-together input[name="bundles"]').forEach(cb => {
      cb.checked = false;
    });
  };

  document.addEventListener('variant:change', onVariantUpdate);
  document.addEventListener('cart:refresh', resetCheckboxes);
  document.addEventListener('ajaxProduct:added', resetCheckboxes);
  window.addEventListener('pageshow', resetCheckboxes);

  if (window.theme?.pubsub) {
    window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, onVariantUpdate);
    window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, resetCheckboxes);
  }
})();
